var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-body" }, [
    _c(
      "table",
      {
        staticClass: "table table-bordered ragistration",
        staticStyle: { "border-collapse": "collapse" }
      },
      [
        _c("tr", [
          _c("th", [_vm._v("氏名")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.result.userName))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("現住所")]),
          _vm._v(" "),
          _c("td", [
            _c("tr", [_vm._v("〒 " + _vm._s(_vm.result.currentPostalCode))]),
            _vm._v(" "),
            _c("tr", [_vm._v(_vm._s(_vm.result.currentAddress))])
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("住民票住所")]),
          _vm._v(" "),
          _c("td", [
            _c("tr", [
              _vm._v("〒 " + _vm._s(_vm.result.residenceCardPostalCode))
            ]),
            _vm._v(" "),
            _c("tr", [_vm._v(_vm._s(_vm.result.residenceCardAddress))])
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("携帯電話")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.result.tel1))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("携帯メールアドレス")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.result.mail))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("緊急連絡先　番号/宛先")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              _vm._s(_vm.result.tel2) + " / " + _vm._s(_vm.result.destination)
            )
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("通勤交通機関及び交通費")]),
          _vm._v(" "),
          _c("td", { staticClass: "m-0 p-0" }, [
            _c("tr", { staticClass: "row m-0" }, [
              _c("th", [_vm._v("バス")]),
              _vm._v(" "),
              _c("td", { staticClass: "m-0 p-0" }, [
                _c("tr", { staticClass: "row m-0" }, [
                  _c("th", { staticClass: "col-6" }, [_vm._v("バス会社名")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-6" }, [
                    _vm._v(_vm._s(_vm.result.busCompanyName))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "row m-0" }, [
                  _c("th", { staticClass: "col-6" }, [
                    _vm._v("自宅最寄停留所")
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-6" }, [
                    _vm._v(_vm._s(_vm.result.busStart))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "row m-0" }, [
                  _c("th", { staticClass: "col-6" }, [_vm._v("駅最寄停留所")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-6" }, [
                    _vm._v(_vm._s(_vm.result.busEnd))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "row m-0" }, [
                  _c("th", { staticClass: "col-6" }, [_vm._v("片道")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-6" }, [
                    _vm._v(_vm._s(_vm.result.busOneWayExpense) + "円")
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "row m-0" }, [
                  _c("th", { staticClass: "col-6" }, [_vm._v("1ヶ月定期代")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-6" }, [
                    _vm._v(_vm._s(_vm.result.busMonthlyExpense) + "円")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("鉄道")]),
              _vm._v(" "),
              _c("td", { staticClass: "m-0 p-0" }, [
                _c("tr", { staticClass: "row m-0" }, [
                  _c("th", { staticClass: "col-6" }, [_vm._v("自宅最寄駅")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-6" }, [
                    _vm._v(_vm._s(_vm.result.trainStartStation))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "row m-0" }, [
                  _c("th", { staticClass: "col-6" }, [_vm._v("会社最寄駅")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-6" }, [
                    _vm._v(_vm._s(_vm.result.trainEndStation))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "row m-0" }, [
                  _c("th", { staticClass: "col-6" }, [_vm._v("使用路線")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-6" }, [
                    _vm._v(_vm._s(_vm.result.trainRoute))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "row m-0" }, [
                  _c("th", { staticClass: "col-6" }, [_vm._v("片道")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-6" }, [
                    _vm._v(_vm._s(_vm.result.trainOneWayExpense) + "円")
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "row m-0" }, [
                  _c("th", { staticClass: "col-6" }, [_vm._v("1ヶ月定期代")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-6" }, [
                    _vm._v(_vm._s(_vm.result.trainMonthlyExpense) + "円")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("合計")]),
              _vm._v(" "),
              _c("td", { staticClass: "m-0 p-0" }, [
                _c("tr", { staticClass: "row m-0" }, [
                  _c("th", { staticClass: "col-6" }, [_vm._v("片道")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-6" }, [
                    _vm._v(_vm._s(_vm.result.sumOneWayExpense) + "円")
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "row m-0" }, [
                  _c("th", { staticClass: "col-6" }, [_vm._v("1ヶ月定期代")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "col-6" }, [
                    _vm._v(_vm._s(_vm.result.sumMonthlyExpense) + "円")
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("給与振込先")]),
          _vm._v(" "),
          _c("td", { staticClass: "m-0 p-0" }, [
            _c("tr", { staticClass: "row m-0" }, [
              _c("th", { staticClass: "col-6" }, [_vm._v("銀行名/銀行番号")]),
              _vm._v(" "),
              _c("td", { staticClass: "col-6" }, [
                _vm._v(
                  _vm._s(_vm.result.bankName) +
                    "/" +
                    _vm._s(_vm.result.bankNumber)
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row m-0" }, [
              _c("th", { staticClass: "col-6" }, [_vm._v("支店名/支店番号")]),
              _vm._v(" "),
              _c("td", { staticClass: "col-6" }, [
                _vm._v(
                  _vm._s(_vm.result.bankBranchName) +
                    "/" +
                    _vm._s(_vm.result.bankBranchNumber)
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row m-0" }, [
              _c("th", { staticClass: "col-6" }, [_vm._v("預金タイプ")]),
              _vm._v(" "),
              _c("td", { staticClass: "col-6" }, [
                _vm._v(_vm._s(_vm.result.bankAccountType))
              ])
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row m-0" }, [
              _c("th", { staticClass: "col-6" }, [_vm._v("口座番号（7ケタ）")]),
              _vm._v(" "),
              _c("td", { staticClass: "col-6" }, [
                _vm._v(_vm._s(_vm.result.bankAccountNumber))
              ])
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row m-0" }, [
              _c("th", { staticClass: "col-6" }, [
                _vm._v("口座名義人（カナ）")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "col-6" }, [
                _vm._v(_vm._s(_vm.result.bankAccountHolder))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.loginUser.userId == _vm.result.userId ||
        _vm.hasAnyRole("ROLE_ADMIN")
          ? _c("tr", [
              _c("th", [_vm._v("基礎年金番号")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.result.basicPensionNumber))])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.loginUser.userId == _vm.result.userId ||
        _vm.hasAnyRole("ROLE_ADMIN")
          ? _c("tr", [
              _c("th", [_vm._v("被保険者番号")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.result.insuredNumber))])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.loginUser.userId == _vm.result.userId ||
        _vm.hasAnyRole("ROLE_ADMIN")
          ? _c("tr", [
              _c("th", [_vm._v("個人番号")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.result.personalNumber))])
            ])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _vm.result.imageUrl
      ? _c("img", {
          staticClass: "card-img-top icon",
          class: "byteImage" + _vm.result.id
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be190820", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be190820","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/common/user/UserWorkRegistrationView.vue
// module id = 369
// module chunks = 0